
import XButton from 'vux/src/components/x-button/index.vue'

export default {
props: {
disabled: {
type: [Boolean],
default: false
}
},
components: {
XButton
},
data () {
return {}
},
methods: {
checkEvent () {
if (this.disabled) {
return
} else {
this.$emit('click')
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/baseComponents/ChooseButton.vue